import React from 'react'
import Restraunt from './components/Basics/Restraunt'

const App = () => {
  return (
    <>
      <Restraunt />
    </>
  )
}

export default App
